// Standard VGA palette (simplified 256-color example for illustration)
export const vgaPalette = [
  '#000000', '#0002aa', '#14aa00', '#00aaaa', '#aa0003', '#aa00aa', '#aa5500', '#aaaaaa',
  '#555555', '#5555ff', '#55ff55', '#55ffff', '#ff5555', '#fd55ff', '#ffff55', '#ffffff',
  '#000000', '#101010', '#202020', '#353535', '#454545', '#555555', '#656565', '#757575',
  '#8a8a8a', '#9a9a9a', '#aaaaaa', '#bababa', '#cacaca', '#dfdfdf', '#efefef', '#ffffff',
  '#0004ff', '#4104ff', '#8203ff', '#be02ff', '#fd00ff', '#fe00be', '#ff0082', '#ff0041',
  '#ff0008', '#ff4105', '#ff8200', '#ffbe00', '#ffff00', '#beff00', '#82ff00', '#41ff01',
  '#24ff00', '#22ff42', '#1dff82', '#12ffbe', '#00ffff', '#00beff', '#0182ff', '#0041ff',
  '#8282ff', '#9e82ff', '#be82ff', '#df82ff', '#fd82ff', '#fe82df', '#ff82be', '#ff829e',
  '#ff8282', '#ff9e82', '#ffbe82', '#ffdf82', '#ffff82', '#dfff82', '#beff82', '#9eff82',
  '#82ff82', '#82ff9e', '#82ffbe', '#82ffdf', '#82ffff', '#82dfff', '#82beff', '#829eff',
  '#babaff', '#cabaff', '#dfbaff', '#efbaff', '#febaff', '#febaef', '#ffbadf', '#ffbaca',
  '#ffbaba', '#ffcaba', '#ffdfba', '#ffefba', '#ffffba', '#efffba', '#dfffba', '#caffbb',
  '#baffba', '#baffca', '#baffdf', '#baffef', '#baffff', '#baefff', '#badfff', '#bacaff',
  '#010171', '#1c0171', '#390171', '#550071', '#710071', '#710055', '#710039', '#71001c',
  '#710001', '#711c01', '#713900', '#715500', '#717100', '#557100', '#397100', '#1c7100',
  '#097100', '#09711c', '#067139', '#037155', '#007171', '#005571', '#003971', '#001c71',
  '#393971', '#453971', '#553971', '#613971', '#713971', '#713961', '#713955', '#713945',
  '#713939', '#714539', '#715539', '#716139', '#717139', '#617139', '#557139', '#45713a',
  '#397139', '#397145', '#397155', '#397161', '#397171', '#396171', '#395571', '#394572',
  '#515171', '#595171', '#615171', '#695171', '#715171', '#715169', '#715161', '#715159',
  '#715151', '#715951', '#716151', '#716951', '#717151', '#697151', '#617151', '#597151',
  '#517151', '#51715a', '#517161', '#517169', '#517171', '#516971', '#516171', '#515971',
  '#000042', '#110041', '#200041', '#310041', '#410041', '#410032', '#410020', '#410010',
  '#410000', '#411000', '#412000', '#413100', '#414100', '#314100', '#204100', '#104100',
  '#034100', '#034110', '#024120', '#014131', '#004141', '#003141', '#002041', '#001041',
  '#202041', '#282041', '#312041', '#392041', '#412041', '#412039', '#412031', '#412028',
  '#412020', '#412820', '#413120', '#413921', '#414120', '#394120', '#314120', '#284120',
  '#204120', '#204128', '#204131', '#204139', '#204141', '#203941', '#203141', '#202841',
  '#2d2d41', '#312d41', '#352d41', '#3d2d41', '#412d41', '#412d3d', '#412d35', '#412d31',
  '#412d2d', '#41312d', '#41352d', '#413d2d', '#41412d', '#3d412d', '#35412d', '#31412d',
  '#2d412d', '#2d4131', '#2d4135', '#2d413d', '#2d4141', '#2d3d41', '#2d3541', '#2d3141',
  '#000000', '#000000', '#000000', '#000000', '#000000', '#000000', '#000000', '#000000'
];

export const STARTING_COLOR = 15; 